import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { redirect } from '../lib/utils/browser';
import { INTUIT_EDUCATION_URL } from '../constants';


const ReturnToIntuitButtonComponent = () => (
    <button
        type="button"
        className="sid-btn"
        aria-label="submit"
        onClick={() => {
            redirect(INTUIT_EDUCATION_URL);
        }}
        onKeyPress={() => {
            redirect(INTUIT_EDUCATION_URL);
        }}
        tabIndex={0}
    >
        <FormattedHTMLMessage id="returnToIntuit" defaultMessage="Return to Intuit" />
    </button>
);

export { ReturnToIntuitButtonComponent };
